import { ConnectedUser } from '../stores/types/connection';

// eslint-disable-next-line import/prefer-default-export
export function getUserWebRTCIdMap(
	connectedUsers: ConnectedUser[],
): Map<string, ConnectedUser> {
	const completeMap = new Map<string, any>();

	for (let i = 0; i < connectedUsers.length; i += 1) {
		if (connectedUsers[i].feedWebRTCIds) {
			const webRTCIds = Array.from(connectedUsers[i].feedWebRTCIds!);

			for (let j = 0; j < webRTCIds.length; j += 1) {
				completeMap.set(webRTCIds[j].toString(), connectedUsers[i]);
			}
		} else if (connectedUsers[i].webrtcID) {
			completeMap.set(connectedUsers[i].webrtcID!.toString(), connectedUsers[i]);
		}
	}

	return completeMap;
}
